import { Injectable } from '@angular/core';
import { Serializable } from './serializable';
export class Alert extends Serializable<Alert>{
    id: string;
    message: string;
    message_type: string;
    user_id: string;
    created_date: number;
	case_number: string;
	case_id: string;
    constructor(id ?: string, message ?: string, message_type ?: string, user_id ?: string, created_date ?: Date, case_number ?: string, case_id ?: string) {
		super();
		this.id = id == null ? '' : id;
		this.message = message == null ? '' : message;
		this.message_type = message_type == null ? '' : message_type;
		this.user_id = user_id == null ? '' : user_id;
		this.created_date = created_date == null ? new Date().getTime() : created_date.getTime();
		this.case_number = case_number == null ? '' : case_number;
		this.case_id = case_id == null ? '' : case_id;
	}
	
	deserialize(input){
		this.id = input.id == null ? '' : input.id;
		this.message = input.message == null ? '' : input.message;
		this.message_type  = input.message_type == null ? '' : input.message_type;
		this.user_id = input.user_id == null ? '' : input.user_id;
		this.created_date = input.created_date == null ? 0 : input.created_date.getTime();
		this.case_number = input.case_number == null ? '' : input.case_number;
		this.case_id = input.case_id == null ? '' : input.case_id;
		return this;
	}

}



// WEBPACK FOOTER //
// ./src/app/main/shared/models/alert.ts